<template>
<div class="text-left min-h-screen bg-gray-200 flex flex-col">
  <textarea name="template" id="" class="sr-only whitespace-pre-wrap" aria-hidden ref="clipboardCode" v-model="clipboard" />
  <div class="w-full p-2 m-auto space-y-4" style="max-width: 65ch">
    <header>
    <h1 class="text-2xl font-semibold text-gray-800">
      Tweet Replacer
    </h1>
  </header>
    <label class="block" for="selecter">
      <p class="text-xs font-semibold text-gray-600 uppercase">
        Mode
      </p>
      <select 
        id="selecter" 
        v-model="mode"
        class="w-full pl-2 pr-8 py-1 appearance-none border border-gray-300 rounded focus:outline-none focus:shadow-outline"
      >
        <option value="" disabled selected>-- select a mode --</option>
        <option 
          :value="option"
          v-for="(option, i) in options"
          :key="i"
        >
          {{ option }}
        </option>
      </select>
    </label>
    <label class="block" for="input">
      <p class="text-xs font-semibold text-gray-600 uppercase">
        Input
      </p>
      <textarea id="input" name="input" type="text" v-model="text" maxlength="280"
        class="h-64 w-full bg-white p-2 text-base font-medium text-gray-800 rounded-md shadow-md focus:outline-none focus:shadow-outline text-left flex items-start justify-start overflow-auto resize-none" 
      />
    </label>
    <label class="block" for="output">
      <p class="text-xs font-semibold text-gray-600 uppercase">
        output
      </p>
      <button id="output" name="output" type="text" @click="copy"
        class="h-64 w-full bg-white p-2 text-base font-medium text-gray-800 rounded-md shadow-md focus:outline-none focus:shadow-outline text-left flex items-start justify-start overflow-auto break-all"
      >
        {{ clipboard }}
      </button>
    </label>
    <p>{{ copiedMessage }}</p>
  </div>
</div>
</template>

<script>
import { ref, computed } from 'vue';
export default {
  name: 'App',
  setup() {
    const clipboardCode = ref('')
    const text = ref('')
    const mode = ref('asterisk')
    const copiedMessage = ref('')
    const options = [
      'asterisk',
      'base64'
    ]
    const clipboard = computed(() => {
      if(mode.value === 'asterisk') return text.value.replace(/[^\s-]/g, '*')
      else if(mode.value === 'base64') return btoa(text.value)
      else return text.value.replace(/[^\s-]/g, '$')
    })
    
    function copy() {
      setTimeout(() => {
        clipboardCode.value.select()
        document.execCommand('copy')
        copiedMessage.value = "copied to keyboard"
        setTimeout(() => {
          copiedMessage.value = ''
        }, 3000);
      });
    }

    return {
      copy,
      clipboardCode,
      clipboard,
      text,
      options,
      copiedMessage,
      mode
    }

  }
}
</script>

<style lang="postcss">
.MathJax_Display, .MJXc-display {
  margin: 1.5rem 0 !important;
}
.hljs{display:block;overflow-x:auto;padding:.5em;background:#1e1e1e;color:#dcdcdc}.hljs-keyword,.hljs-literal,.hljs-name,.hljs-symbol{color:#569cd6}.hljs-link{color:#569cd6;text-decoration:underline}.hljs-built_in,.hljs-type{color:#4ec9b0}.hljs-class,.hljs-number{color:#b8d7a3}.hljs-meta-string,.hljs-string{color:#d69d85}.hljs-regexp,.hljs-template-tag{color:#9a5334}.hljs-formula,.hljs-function,.hljs-params,.hljs-subst,.hljs-title{color:#dcdcdc}.hljs-comment,.hljs-quote{color:#57a64a;font-style:italic}.hljs-doctag{color:#608b4e}.hljs-meta,.hljs-meta-keyword,.hljs-tag{color:#9b9b9b}.hljs-template-variable,.hljs-variable{color:#bd63c5}.hljs-attr,.hljs-attribute,.hljs-builtin-name{color:#9cdcfe}.hljs-section{color:gold}.hljs-emphasis{font-style:italic}.hljs-strong{font-weight:700}.hljs-bullet,.hljs-selector-attr,.hljs-selector-class,.hljs-selector-id,.hljs-selector-pseudo,.hljs-selector-tag{color:#d7ba7d}.hljs-addition{background-color:#144212;display:inline-block;width:100%}.hljs-deletion{background-color:#600;display:inline-block;width:100%}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>